import { IPlayer } from "../../interfaces";

const setPlayersInTheNewOrder = (playersOrderedInGameObject: IPlayer[] | undefined, userData: any): any => {

    if (!playersOrderedInGameObject)

    return []

    let theUserFromUserData: IPlayer | undefined;
    let playersInTheNewOrder: (IPlayer | undefined)[] = [];
    
    playersOrderedInGameObject.forEach((player: IPlayer, index: number) => {
        if(userData != undefined && player != undefined) {
            if (player.email !== userData.email) 
                playersInTheNewOrder.push(player);

            if(player.email === userData.email)
                theUserFromUserData = player;
        }

    })

    playersInTheNewOrder.push(theUserFromUserData);

    return playersInTheNewOrder;

};

export default setPlayersInTheNewOrder;